import CookieUtils from "./utils/cookie_utils";

export class PlayerData {
  constructor(id, adsEnabled=true, playUUID = null){
    this._el = document.getElementById(id);
    this._id = id;
    this._geoblocked = false;
    this._adsEnabled = adsEnabled;
    this._playUUID = playUUID;
  }

  id(){
    return this._id;
  }

  adsEnabled(){
    return this._adsEnabled;
  }

  playUUID() {
    return this._playUUID;
  }

  setGeoblocked(value){
    this._geoblocked = value;
  }

  isGeoblocked(){
    return this._geoblocked;
  }

  el(){
    return this._el || document.createElement("null");
  }

  playerId(){
    return this.el().getAttribute('data-player-id');
  }

  vjsClipHlsUrl(){
    return this.el().getAttribute('data-vjs-clip-hls-url');
  }

  hlsUrlWithEmbedParam() {
    if (this.embed() == 'true' && !this.isLivestreaming()) {
      try{
        let url = new URL(this.vjsClipHlsUrl());
        url.searchParams.append('embed','true');
        return url.toString();
      } catch(e){
        return this.vjsClipHlsUrl() + "?embed=true";
      }
    }
    return this.vjsClipHlsUrl();
  }

  vjsClipDashUrl(){
    return this.el().getAttribute('data-vjs-clip-dash-url');
  }

  type(){
    return this.el().getAttribute('data-type') || '';
  }

  videoDuration(){
    return parseInt(this.el().getAttribute('data-video-duration')) || 0;
  }

  autoplay(){
    return this.el().getAttribute('data-autoplay') === "true";
  }

  mute(){
    return this.el().getAttribute('data-mute') === "true";
  }

  videoId(){
    return parseInt(this.el().getAttribute('data-video-id')) || 0;
  }

  videoTitle() {
    return this.el().getAttribute('data-video-title') || '';
  }

  geoblock(){
    return this.el().getAttribute('data-geoblock');
  }

  geoblockUrl(){
    return this.el().getAttribute('data-geoblock-url') || '';
  }

  resolutionMapping(){
    let mapping  = [];
    try {
      mapping = JSON.parse(this.el().getAttribute('data-resolution-mapping'));
    } catch {}
    return mapping || [];
  }

  getDocumentReferrer() {
    return document.referrer;
  }

  pauseAdDomId() {
    return this.el().getAttribute('data-advertisement-pause-ad-dom-id') || '';
  }

  overlayAdDomId() {
    return this.el().getAttribute('data-advertisement-overlay-ad-dom-id') || '';
  }

  overlayFirstRenderTime() {
    return parseInt(this.el().getAttribute('data-advertisement-overlay-first-render-time'));
  }

  overlayRefreshInterval() {
    return parseInt(this.el().getAttribute('data-advertisement-overlay-refresh-interval'));
  }

  squeezeFrameFirstRenderTime() {
    return parseInt(this.el().getAttribute('data-advertisement-squeeze-frame-first-render-time'));
  }

  adsBlacklist() {
    let domainList = [];
    try {
      domainList = JSON.parse(this.el().getAttribute('data-domain-ads-blacklist')) || [];
    } catch(e) {}

    return domainList;
  }

  videoImageUrl() {
    return this.el().getAttribute('data-video-image-url');
  }

  videoBlockerImageUrl() {
    return this.el().getAttribute('data-video-blocker-image-url');
  }

  adult(){
    return this.el().getAttribute('data-adult') === "true" && (this.embed() == "false");
  }

  endCreditTime() {
    return Number(this.el().getAttribute("data-end-credit-time"));
  }

  streamType(){
    return this.el().getAttribute("data-livestreaming-stream-type");
  }

  isVideo(){
    return this.type() == "Video";
  }

  isLivestreaming(){
    return this.type() == "Livestreaming";
  }

  thumbnails(){
    let data = {};
    try {
      data = JSON.parse(this.el().getAttribute("data-thumbnails")) || {};
    }catch(e){
      console.error(e);
    }
    return data;
  }

  embed(){
    return this.el().getAttribute('data-embed');
  }

  sticky(){
    return this.el().getAttribute('data-sticky');
  }

  embedPosition(){
    return this.el().getAttribute('data-embed-position');
  }

  videoWithToken(){
    return this.el().getAttribute('data-video-has-token') == "true";
  }

  subtitles(){
    return this.el().getAttribute('data-subtitles');
  }

  sendPlayToggle(){
    return this.el().getAttribute('data-send-play-toggle') == "true";
  }

  sendPlayInterval(){
    return parseInt(this.el().getAttribute('data-send-play-interval'));
  }

  drmEnabled(){
    return this.el().getAttribute('data-drm-enabled') == "true";
  }

  siteId(){
    return this.el().getAttribute('data-drm-siteid') || "MQDT";
  }

  shareButtonEnabled(){
    return this.el().getAttribute('data-share-button-enabled') == "true";
  }

  filmId(){
    return parseInt(this.el().getAttribute('data-film-id')) || 0;
  }

  filmTitle(){
    return this.el().getAttribute('data-film-title') || "";
  }

  filmGenres(){
    return this.el().getAttribute('data-film-genres') || "";
  }

  videoDescription() {
    return this.el().getAttribute('data-video-description');
  }

  seasonId(){
    return parseInt(this.el().getAttribute('data-season-id')) || 0;
  }

  seasonName(){
    return this.el().getAttribute('data-season-name') || "";
  }

  episodeNumber(){
    return parseInt(this.el().getAttribute('data-episode-number')) || 0;
  }

  userIsPremier(){
    var _vidioCookies = CookieUtils.getCookie("_vidio") == "true";
    return _vidioCookies;
  }

  setUserPremier(){
    var _vidioCookiesPremier = CookieUtils.setCookie("_vidio", "true")
    return _vidioCookiesPremier;
  }

  isPremier(){
    return this.el().getAttribute('data-video-premier') == "true";
  }

  genreIds() {
    var json = [];
    var ids = this.el().getAttribute("data-genre-ids");

    try{
      json = JSON.parse(ids);
    }catch(e){
      json = [];
    }

    return json;
  }

  tokenRefreshCount(){
    return parseInt(this.el().getAttribute('data-vod-token-refresh-count')) || 0;
  }

  tokenDuration() {
    return parseInt(this.el().getAttribute('data-token-duration')) || 0;
  }

  episodesList() {
    try {
      return JSON.parse(this.el().getAttribute('data-episodes-list')) || [];
    } catch(e) {
      return [];
    }
  }

  seasonsList() {
    try {
      return JSON.parse(this.el().getAttribute('data-seasons-list')) || [];
    } catch(e) {
      return [];
    }
  }

  testMode(){
    return this.el().getAttribute('data-test-mode') == 'true';
  }

  testMobileSite() {
    return this.el().getAttribute('data-test-mobile-site') == 'true';
  }

  unskippableAdDuration() {
    return Number(this.el().getAttribute('data-unskippable-ad-duration')) || 15;
  }

  adPreferredBitrate() {
    return Number(this.el().getAttribute('data-ad-preferred-bitrate')) || 500;
  }

  vastMediaDownloadTimeout() {
    return Number(this.el().getAttribute('data-vast-media-download-timeout')) || -1;
  }

  preview() {
    return this.el().getAttribute('data-preview') === 'true';
  }

  previewDuration() {
    return Number(this.el().getAttribute('data-preview-duration')) || -1;
  }

  userAvatarUrl(){
    return this.el().getAttribute('data-user-avatar-url') || '';
  }

  watchpageUrl(){
    return this.el().getAttribute('data-watchpage-url') || '';
  }

  userProfileUrl(){
    return this.el().getAttribute('data-user-profile-url') || '';
  }

  hdcpEnabled() {
    return this.el().getAttribute('data-hdcp-enabled') === 'true';
  }

  dvrEnabled() {
    return this.el().getAttribute('data-dvr-enabled') === 'true';
  }

  videoUserId() {
    return this.el().getAttribute('data-video-user-id') || '';
  }

  videoUsername() {
    return this.el().getAttribute('data-video-username') || '';
  }

  videoUserRole() {
    return this.el().getAttribute('data-video-user-role') || '';
  }

  videoTags() {
    return this.el().getAttribute('data-video-tags') || '';
  }

  videoChannel() {
    return this.el().getAttribute('data-video-channel') || '';
  }

  videoChannelId() {
    return this.el().getAttribute('data-video-channel-id') || '';
  }

  livestreamingTags() {
    return this.el().getAttribute('data-livestreaming-tags') || '';
  }

  contentMainGenre() {
    return this.el().getAttribute('data-main-genre') || '';
  }

  contentGenres() {
    return this.el().getAttribute('data-genres') || '';
  }

  contentCountry() {
    return this.el().getAttribute('data-content-country') || '';
  }

  contentGroup() {
    return this.el().getAttribute('data-group') || '';
  }

  contentEvents() {
    return this.el().getAttribute('data-events') || '';
  }

  contentContentType() {
    return this.el().getAttribute('data-content-content-type') || '';
  }

  whitelistedLineItemIds() {
    const ids = this.el().getAttribute('data-advertisement-whitelisted-line-item');
    return ids == null ? [] : ids.split(",")
  }

  whitelistedCreativeIds() {
    const ids = this.el().getAttribute('data-advertisement-whitelisted-creative');
    return ids == null ? [] : ids.split(",")
  }

  customSkipAdButtonOffset() {
    return Number(this.el().getAttribute('data-custom-skip-ad-button-offset')) || 5;
  }

  chaptersIntroStart() {
    return Number(this.el().getAttribute('data-chapters-intro-start')) || -1;
  }

  chaptersIntroEnd() {
    return Number(this.el().getAttribute('data-chapters-intro-end')) || -1;
  }

  chaptersCreditStart() {
    return Number(this.el().getAttribute('data-chapters-credit-start')) || -1;
  }

  chaptersCreditEnd() {
    return Number(this.el().getAttribute('data-chapters-credit-end')) || -1;
  }

  contentGatingLogin() {
    return this.el().getAttribute('data-content-gating-login') === 'true' && window.isUserSignedIn === false;
  }

  contentGatingDuration() {
    return Number(this.el().getAttribute('data-content-gating-duration')) || -1;
  }

  contentGatingUrl(){
    return this.el().getAttribute('data-content-gating-url');
  }

  adConfig() {
    return this.el().getAttribute('data-ad-config');
  }

  cdnName() {
    return this.el().getAttribute('data-cdn');
  }

  contentRatingOption() {
    return this.el().getAttribute('data-content-rating-option') || '';
  }

  pauseAdRequestDelay() {
    return Number(this.el().getAttribute('data-pause-ad-request-delay')) || 0;
  }

  adsVolumeGapSync() {
    return Number(this.el().getAttribute('data-ads-volume-gap-sync')) || 0;
  }

  adsMidrollMinimumWatchDuration() {
    return Number(this.el().getAttribute('data-ads-midroll-minimum-watch-duration')) || 0;
  }
}
